import React from "react";

import './EditAlertNoteModal.scss'
import {Modal, TextArea} from "@carbon/react";
import {useRecoilState, useRecoilValue} from "recoil";
import {
  editAlarmNoteModalNotesState,
  editAlarmNoteModalOpenState,
  selectedAlarmState
} from "../../../state/alerts_table";
import {grpcAlarmServiceSelector} from "../../../state/grpc";
import {ADD, useToastContext} from "../../Toast";

const EditAlertNoteModal = () => {
  const { toastDispatch } = useToastContext();
  const [selectedAlarm, setSelectedAlarm] = useRecoilState(selectedAlarmState)
  const [editAlarmNoteModalOpen, setEditAlarmNoteModalOpen]  = useRecoilState(editAlarmNoteModalOpenState)
  const [alarmNoteModalNotes, setAlarmNoteModalNotes]  = useRecoilState(editAlarmNoteModalNotesState)
  const alarmsService = useRecoilValue(grpcAlarmServiceSelector)

  return (
    <Modal
      open={editAlarmNoteModalOpen}
      modalHeading="Modifica le note aggiuntive dell'allarme "
      modalLabel="Dati allarme"
      primaryButtonText="Salva"
      secondaryButtonText="Annulla"
      onRequestSubmit={() => {
        const req = new proto.api.UpdateAlarmRequest()
        let alarm = new proto.api.Alarm()
        alarm.setId(selectedAlarm.id)
        alarm.setNotes(alarmNoteModalNotes)
        req.setAlarm(alarm)
        alarmsService.updateAlarm(req, null, (err, resp) => {
          if (err != null) {
            console.error(err)
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione fallita",
                content: "Impossibile salvare le note. Riprova più tardi",
                kind: "error",
                caption: err.message
              }
            })
          } else {
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione completata con successo",
                content: "Note allarme '" + selectedAlarm.id +  "' salvate con successo",
                kind: "success"
              }
            })
            setEditAlarmNoteModalOpen(false)
          }
        })
      }}
      onRequestClose={() => {
        setEditAlarmNoteModalOpen(false)
      }}>
      <p style={{marginBottom: 'rem'}}>
        Puoi scrivere un testo lungo a piacere. Queste note verranno salvate nell'allarme selezionato e
        non verranno propagate su altri allarmi dello stesso cliente. Il testo sarà consultabile da qualsiasi
        altro utente dalla dashboard sul menu espandibile dell'allarme stesso, oppure dallo storico allarmi.
      </p>
      <br/>
      <TextArea
        data-modal-primary-focus
        maxCount={1000}
        value={alarmNoteModalNotes}
        onChange={ev => {
          setAlarmNoteModalNotes(ev.target.value)
        }}
        id="alarm-notes"
        labelText="Note allarme"
        style={{marginBottom: 'rem'}}
      />
    </Modal>
  );
}

export default EditAlertNoteModal